module.exports = __webpack_public_path__ + "img/radar.7bd88a15.svg";